export default __webpack_public_path__ + "static/char-s-47-en-235758514d113936e4d4d91be6f509f0.webp";